import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import ErrorBoundary from 'components/ErrorBoundary';
import TeamTypeFilter from 'components/TeamTypeFilter';
import renderTeamTypeIcon from 'screens/TeamPickerModal/renderTeamTypeIcon';
import { useFetchTeams, useFetchTeamTypes } from 'actions/team';
import i18n from 'i18n';
import { jsx as _jsx } from "react/jsx-runtime";
export var noOwningTeamItem = {
  id: '',
  name: i18n.t('amount_none'),
  // These values below are added simply to match the TeamListItem type
  // and have no meaning otherwise
  role: 'member',
  isSmartTeam: false,
  teamType: {
    id: '',
    name: '',
    colour: ''
  },
  is_deleted: false
};
function OwningTeamPickerModal(_ref) {
  var contentIds = _ref.contentIds,
    _ref$hideNoneOption = _ref.hideNoneOption,
    hideNoneOption = _ref$hideNoneOption === void 0 ? false : _ref$hideNoneOption,
    selectableTeamIds = _ref.selectableTeamIds,
    defaultSelectedOwningTeam = _ref.defaultSelectedOwningTeam,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedTeamTypeId = _useState4[0],
    setSelectedTeamTypeId = _useState4[1];
  var _useFetchTeamTypes = useFetchTeamTypes(),
    teamTypes = _useFetchTeamTypes.items;
  var renderFilter = function renderFilter() {
    return /*#__PURE__*/_jsx(TeamTypeFilter, {
      value: selectedTeamTypeId,
      onChange: setSelectedTeamTypeId,
      teamTypes: teamTypes
    });
  };
  var _useFetchTeams = useFetchTeams({
      teamTypeId: selectedTeamTypeId,
      search: searchValue,
      teamIds: selectableTeamIds,
      contentIds: contentIds,
      includeCalculatedTeams: false
    }),
    items = _useFetchTeams.items,
    hasNextPage = _useFetchTeams.hasNextPage,
    fetchNextPage = _useFetchTeams.fetchNextPage,
    isError = _useFetchTeams.isError,
    isLoading = _useFetchTeams.isLoading,
    isFetchingNextPage = _useFetchTeams.isFetchingNextPage;
  var title = t('actions_change_owning_team');
  var allItems = hideNoneOption ? items : [noOwningTeamItem].concat(_toConsumableArray(items));
  return /*#__PURE__*/_jsx(Modal, {
    id: "owning-team-picker-modal",
    "aria-label": title,
    onRequestClose: onClose,
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(ItemPicker, {
        isSingleItemPicker: true,
        title: title,
        defaultSelectedItems: defaultSelectedOwningTeam ? [defaultSelectedOwningTeam] : [],
        onSearchValueChange: setSearchValue,
        renderItemIcon: teamTypes.length > 1 ? renderTeamTypeIcon : null,
        onSubmit: onSubmit,
        onClose: onClose,
        items: allItems,
        hasNextPage: hasNextPage,
        onFetchNextPage: fetchNextPage,
        renderFilterMenu: teamTypes.length > 1 ? renderFilter : null,
        isFetchingNextPage: isFetchingNextPage,
        isError: isError,
        isLoading: isLoading
      })
    })
  });
}
export default OwningTeamPickerModal;